import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

interface CoursesProps {}

export const Courses: React.FC<CoursesProps> = () => {
  const courses = [
    {
      courseId: "1",
      courseName: "Default Opt - UPG_1.2",
      courseUrl: "/assignment/course/Default-UPG1.2/start.htm",
    },
    {
      courseId: "2",
      courseName: "Default Opt - UPG_2004",
      courseUrl: "/assignment/course/Default-UPG2004/start.htm",
    },
  ];
  const navigate = useNavigate();

  const handleCardClick = (courseUrl: string) => {
    console.log("courseUrl", courseUrl);
    navigate("/assignment", { state: { courseUrl: courseUrl } });
  };
  return (
    <>
      {courses.map((course) => (
        <Card
          key={course.courseId}
          sx={{
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            cursor: "pointer",
          }}
          onClick={() => handleCardClick(course.courseUrl)}
        >
          <CardContent>
            <Typography variant="h6" fontWeight="bold">
              Course {course.courseName}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </>
  );
};
